import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';
import type { ActiveIngredientDTO } from './useGetActiveIngredients';

export interface CreateActiveIngredientPayload {
	name: string;
}

export const useCreateActiveIngredient = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (payload: CreateActiveIngredientPayload) => {
			try {
				const { data } = await api.post<ActiveIngredientDTO>('/active-ingredients/create', payload);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar ingrediente ativo');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['active-ingredients'] });
		},
	});
};
